import styl, {keyframes} from 'styled-components';
import {LoaderProps} from '.';
import {Theme} from '@src/ds/components/bosons/Theme/styles-components';

const getLoaderColor = (theme: Theme, variant: LoaderProps['variant']) => {
  switch (variant) {
    case 'white':
      return theme.color.white;
    case 'red':
      return theme.color.red[11];
    case 'blue':
      return theme.color.indigo[11];
    case 'green':
      return theme.color.green[11];
    case 'currentcolor':
      return 'currentcolor';
    default:
      break;
  }
};

const rotateAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const LoaderWrapper = styl.div`
  &.loader--round{
    box-sizing: border-box;
    padding: 3px;
    width: 24px;
    height: 24px;
  }
`;

export const LoaderSvgStyl = styl.svg<LoaderProps>`
  font-size: 18px;
  color: ${({theme, variant}) => getLoaderColor(theme, variant)};
  animation: ${rotateAnimation} 1s linear infinite;

  path:nth-child(0) {
    opacity: 1;
  }

  path:nth-child(1) {
    opacity: 0.88;
  }

  path:nth-child(2) {
    opacity: 0.76;
  }

  path:nth-child(3) {
    opacity: 0.64;
  }

  path:nth-child(4) {
    opacity: 0.52;
  }

  path:nth-child(5) {
    opacity: 0.40;
  }

  path:nth-child(6) {
    opacity: 0.28;
  }

  path:nth-child(7) {
    opacity: 0.16;
  }

  path:nth-child(8) {
    opacity: 0.04;
  }
`;

export const LoaderInlineStyl = styl.div`
  background: ${({theme}) => theme.color.grey[3]};
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  width: 180px;
  height: 8px;

  > .loader--inline-bar {
    animation: load 3s ease-in-out infinite forwards;
    background: ${({theme}) => theme.color.indigo[8]};
    width: 90px;
    height: 8px;
  }

  @keyframes load {
    0% { width: 50%; }
    50% { transform: translateX(100%); }
  }
`;

export const PageLoader = styl.div`
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;

  &.page-loader--studio {
    // height: calc(100% + 94px);
    box-sizing: border-box;
  }
`;
